import { useResolve } from '@visiba/instantiation';
import { useNavigate } from 'react-router-dom';
import { SessionController } from '../../session.controller';
import { useEffect } from 'react';
import { Spinner } from '@cellula/react';

interface Props {}

export function Session(_: Props): JSX.Element {
	const navigate = useNavigate();
	const controller = useResolve(SessionController);

	function handlePostEventFromIframe(messageEvent: MessageEvent) {
		const { event, data } = messageEvent.data;

		if (data === undefined) return;

		if (event === 'RedRobinSessionCompleted') {
			if (data.url) {
				window.location.href = data.url;
			} else {
				navigate('../thank-you');
			}
		}
	}

	useEffect(function whenMounted() {
		window.addEventListener('message', handlePostEventFromIframe, false);

		if (controller.sessionUrl === null) {
			navigate('../session-not-found');
		}

		return () => {
			window.removeEventListener('message', handlePostEventFromIframe, false);
		};
	}, []);

	if (!controller.sessionUrl) {
		return <Spinner size='large' />;
	}

	return <iframe src={controller.sessionUrl} width={'100%'} height={'100%'}></iframe>;
}
